import { GenericValue } from 'hisng';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HisBaseGlobalsService } from 'hisng';
import {
    ENGLISH_DATE_TIME_FORMAT_PLACEHOLDER,
    ENGLISH_DATE_TIME_PIPE_FORMAT,
    GERMAN_DATE_TIME_FORMAT_PLACEHOLDER,
    GERMAN_DATE_TIME_PIPE_FORMAT
} from 'app/rm/erp/common/model/constants';
import { Assets } from '../../model/assets';

@Component( {
    selector: 'erp-businesstripapplication-assets',
    templateUrl: './businesstripapplication-assets.component.html'
} )
export class BusinesstripApplicationAssetsComponent implements OnInit {
    @Input() assets: Assets = new Assets();
    @Output() readonly assetsChange = new EventEmitter<Assets>();
    readonly dateTimeFormat: string;
    readonly datePlaceholderFormat: string;

    constructor(
        private readonly hisBaseGlobalsService: HisBaseGlobalsService,
    ) {
        if ( this.hisBaseGlobalsService.getLanguage() === 'de' ) {
            this.dateTimeFormat = GERMAN_DATE_TIME_PIPE_FORMAT;
            this.datePlaceholderFormat = GERMAN_DATE_TIME_FORMAT_PLACEHOLDER;
        } else {
            this.dateTimeFormat = ENGLISH_DATE_TIME_PIPE_FORMAT;
            this.datePlaceholderFormat = ENGLISH_DATE_TIME_FORMAT_PLACEHOLDER;
        }
    }

    ngOnInit(): void {
    }

    onModelChange( changedValue: string | Date | GenericValue ): void {

        if ( !this.assets.costCoverage ) { this.assets.costCoverageAmount = undefined; }
        if ( !this.assets.researchFundsApproved ) { this.assets.researchFundsAmount = undefined; }
        if ( !this.assets.facultyResourcesApproved ) { this.assets.facultyResourcesAmount = undefined; }
        if ( !this.assets.internationalBudget ) { this.assets.internationalBudgetAmount = undefined; }
        if ( !this.assets.ownProjectFunds ) { this.assets.ownProjectFundsAmount = undefined; }
        if ( !this.assets.fee ) { this.assets.feeAmount = undefined; }

        this.assetsChange.emit( this.assets );
    }
}
